












import { PropType, defineComponent } from '@vue/composition-api';
import { Issue } from '../../dataType';
import { useLocale } from '../../hooks/useLocale';

export default defineComponent({
  props: {
    issue: {
      type: Object as PropType<Issue>,
      required: true
    }
  },
  setup() {
    const { t } = useLocale();
    return {
      t
    };
  }
});
